import { productLoadIntoList } from './products';

const html5QrCode = new Html5Qrcode('reader');

const qrCodeSuccessCallback = (decodedText, decodedResult) => {
  document.getElementById('show-qr-code-button').click();
  const productList = document.getElementById('product-list');
  while (productList.firstChild) {
    productList.removeChild(productList.lastChild);
  }
  productLoadIntoList(decodedText, true);
  // document.getElementById('html5-qrcode-button-camera-stop').click();
};

const showQrCodeButton = document.getElementById('show-qr-code-button');
showQrCodeButton.addEventListener('click', function() {
  if (document.getElementById('qr-code-container').classList.contains('visible')) {
    document.getElementById('qr-code-container').classList.remove('visible');
    showQrCodeButton.innerText = 'Scanna streckkod';
    html5QrCode.stop();
  } else {
    document.getElementById('qr-code-container').classList.add('visible');
    showQrCodeButton.innerText = 'Dölj streckkodsläsaren';
    const config = { fps: 10, qrbox: { width: 250, height: 250 } };
    html5QrCode.start({ facingMode: 'environment' }, config, qrCodeSuccessCallback);
  }
});
